module.exports = __webpack_public_path__ + "static/media/phone.7370772d.png";